import { render, staticRenderFns } from "./AccountTransactionPayoutCard.vue?vue&type=template&id=6dca4966&scoped=true"
import script from "./AccountTransactionPayoutCard.vue?vue&type=script&lang=js"
export * from "./AccountTransactionPayoutCard.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactionPayoutCard.vue?vue&type=style&index=0&id=6dca4966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca4966",
  null
  
)

export default component.exports